<template>
  <v-app>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="desserts"
    :single-select="singleSelect"
    item-key="COMPANY_ID"
    show-select
    style="padding:25px">

    <template v-slot:top>
      <div>
          <div>
            <v-toolbar style="box-shadow:none !important">
              <v-toolbar-title><b>{{title}}</b></v-toolbar-title>
              <v-spacer></v-spacer>
              
              <v-spacer></v-spacer>
              <v-breadcrumbs>Master Data / Company</v-breadcrumbs>
              <v-btn icon v-on:click="getData">
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-toolbar>

            <div style="padding:0px 25px">
                <v-layout row>
                  
                  <v-flex md8>
                      <v-btn rounded style="margin-top:15px" color="primary" large v-on:click="modalForm()">
                          <v-icon dark style="margin-right:10px">mdi-plus</v-icon>
                          Add Data
                      </v-btn>
                  </v-flex>

                  <v-flex md4>
                      <v-col cols="12" sm="6" md="12">
                        <v-text-field
                          
                          v-model="val"
                           v-on:keyup.enter="getData()"
                          placeholder="Enter Your Keywords"
                          solo
                          append-icon="search"
                        ></v-text-field>
                      </v-col>
                  </v-flex>

                </v-layout>   
            </div>
        </div>
      </div>

      <v-dialog
        v-model="modal_form"
        max-width="500px"
      >
        <v-card>
          <v-card-title>
            Company
          </v-card-title>
          <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
              >
                  <div style="padding:10px">
                      <label>
                          Company ID
                      </label>
                      <v-text-field
                        v-model="company_id"
                        :rules="rules"
                        :disabled="disabled"
                        placeholder="Enter Company ID"
                        required
                        solo
                      ></v-text-field>

                      <label>
                          Company Name
                      </label>
                      <v-text-field
                        v-model="company_name"
                        :rules="rules"
                        placeholder="Enter Company Name"
                        required
                        solo
                      ></v-text-field>

                      <label>
                          Company Initial
                      </label>
                      <v-text-field
                        v-model="shortname"
                        :rules="rules"
                        placeholder="Enter Company Initial"
                        required
                        solo
                      ></v-text-field>

                      <label>
                          City
                      </label>
                      <v-text-field
                        v-model="city"
                        :rules="rules"
                        placeholder="Enter City"
                        required
                        solo
                      ></v-text-field>
                      
                      <label>
                          Server
                      </label>
                      <v-select 
                        item-text="SERVER_CODE"
                        item-value="SERVER_NAME"
                        v-model="server"
                        :items="list_server"
                        :rules="rules"
                        label="Choose Server"
                        v-bind:value="{ id: SERVER_CODE, text: SERVER_NAME }"
                        solo
                      ></v-select>
                  </div>
                        
                  <div align="right">
                      
                      <v-btn
                      color="primary"
                      text
                      @click="modal_form = false"
                      >
                        Close
                      </v-btn>

                      <v-btn
                      color="primary"
                      text
                      :loading="loading"
                      v-on:click="processForm"
                      >
                        Process
                      </v-btn>
                </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>


    </template>

    <template v-slot:item.status="{ item }">
        <v-chip color="success" v-if="item.STATUS=='Y'">Active</v-chip>
        <v-chip color="error" v-if="item.STATUS=='N'">Inactive</v-chip>
    </template>

    <template v-slot:item.action="{ item }">
      <v-icon
        medium
        class="mr-2"
        @click="edit(item)"
      >
        mdi-file-edit
      </v-icon>

      <v-icon
        medium
        class="mr-2"
        color="error"
        @click="changeStatus(item,'N')"
        v-if="item.STATUS=='Y'"
      >
         mdi-close-circle
      </v-icon>

      <v-icon
        medium
        class="mr-2"
        color="success"
        @click="changeStatus(item,'Y')"
        v-if="item.STATUS=='N'"
      >
         mdi-check-circle
      </v-icon>


    </template>
  </v-data-table>
  </v-app>
</template>


<script>
export default {
    methods: {
        getData(){
         var self = this;
          var val  = self.val; 
         
          var url  = self.base_url + "master/company";
          this.axios.post(url , {
              param:val,
          })
          .then(function (response) {
              self.desserts = response.data;
          });
      },
      modalForm(){
        var self = this;
        self.modal_form = true;
        self.disabled = false;
        self.reset();
      },
      edit(item){
          var self = this;
          self.modal_form = true;
          
          self.company_id = item.COMPANY_ID;
          self.company_name = item.COMPANY_NAME;
          self.shortname = item.SHORTNAME;
          self.city = item.CITY;
          self.server = item.SERVER_CODE;
          self.type = "UPDATE";
          self.disabled = true;
      },
      reset () {
        this.company_id = "";
        this.$refs.form.reset();
        this.type = "INSERT";
      },
      processForm(){
        var self = this;
        if (self.$refs.form.validate()) {
          var type = self.type;
          var url = "";
          self.loading = true;

          if(type=="UPDATE"){
              url  = self.base_url + "master/update_company";
          }else{
              url  = self.base_url + "master/add_company";
          }
          
          self.axios.post(url , {
              company_id : self.company_id,
              company_name : self.company_name,
              shortname : self.shortname,
              city : self.city,
              server : self.server,
              type: self.type

          })
          .then(function (response) {
              if(response.data==true){
                self.modal_form = false;
                alert("Data succesfully saved");

              }else{
                alert(response.data)
              }
              self.getData();
              self.loading = false;
          });
        }
      },
      changeStatus(item,status){
        var self = this;
        var url  = self.base_url + "master/change_status";
         
        var text_confirm = 'Are you sure you want to Deactivated this data ?';
        
        if(status=='Y'){
          text_confirm = 'Are you sure you want to Activated this data ?';
        }

        this.$dialog.confirm({
          text: text_confirm,
          overlay:true,
          actions: {
              false: 'No',
              true: {
                color: 'red',
                text: 'Yes',
                handle: () => {
                     self.axios.post(url , {
                        id : item.COMPANY_ID,
                        status : status,
                        table : 'tm_company',
                        field : 'COMPANY_ID'
                    })
                    .then(function (response) {
                        alert(response.data);
                        self.getData();
                    });                   
                }
              }
            }
        });
      },
      getServer(){
        var self = this;
        var url = self.base_url + "dropdown/server";
        self.axios.get(url).then(function (response) {
            self.list_server = response.data;
        })
      }
    },
    mounted(){
        this.getData();
        this.getServer();
    },
    data () { 
      return {
        name : "Company",
        title : "Data Company",
        dialog: false,
        widgets: false,
        singleSelect: false,
        selected: [],
        showSelect:false,
        val:'',
        headers: [
          { text: 'Company ID', value: 'COMPANY_ID',width:150},
          { text: 'Company Name', value: 'COMPANY_NAME',width:330},
          { text: 'Company Initial', value: 'SHORTNAME',width:180},
          { text: 'City', value: 'CITY',width:250},
          { text: 'Server Code', value: 'SERVER_CODE'},
          { text: 'Status', value: 'status', sortable: true},
          { text: 'Action', value: 'action', sortable: false,width:120},
          
        ],
         desserts: [],
         modal_detail:false,
         detail:[],
         modal_form:false,
         rules : [
           v => !!v || 'Form is required',
           //v => (v && v.length <= 10) || 'This form must be less than 10 characters',
         ],

        //form..............................
        company_id : "",
        company_name : "",
        shortname : "",
        city : "",
        type : "",
        disabled : false,

        //storage.....................................
        storage_user_id : localStorage.getItem("user_id"),
        storage_username : localStorage.getItem("username"),
        storage_fullname : localStorage.getItem("fullname"),
        storage_company_id : localStorage.getItem("company_id"),
        storage_company_name : localStorage.getItem("company_name"),
        storage_role : localStorage.getItem("role"),
        storage_departement_id : localStorage.getItem("departement_id"),
        
      }
    },
  }
</script>
